export default () => {
  const accordionActive = 'accordion__title--active';
  [...document.querySelectorAll('.accordion__title')].forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;

      if (!trigger.classList.contains(accordionActive)) {
        trigger.classList.add(accordionActive);
        content.style.height = `${content.scrollHeight}px`;
      } else {
        trigger.classList.remove(accordionActive);
        content.style.height = 0;
      }
    });
  });
};
